// extracted by mini-css-extract-plugin
export default {"container":"PrimaryReportTabList_container__Ld6cu","item":"PrimaryReportTabList_item__1fXRz"};